import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRecycle } from '@fortawesome/free-solid-svg-icons'
import { SetUnbalanceRevertDialog, SecondaryCta } from 'components'
import React from 'react'

function GridUnbalanceRevert({ row }) {
  return (
    <div className="flex flex-row-reverse flex-nowrap justify-between items-center gap-4 w-full">
      <SetUnbalanceRevertDialog
        togglerComponent={SecondaryCta}
        togglerProps={{
          size: 'grid',
          className: 'min-w-[20em]',
        }}
        rowData={row}
      >
        <FontAwesomeIcon icon={faRecycle} fixedWidth />
      </SetUnbalanceRevertDialog>
    </div>
  )
}

export const MemoizedGridUnBalanceRevert = React.memo(GridUnbalanceRevert)
